const trimSlash = (url: string): string => url.replace(/\/$/, '');

/** The Customer API: login and all the portal data. It needs the public API key (`VITE_API_KEY`) on every call. */
export const PORTAL_API_BASE_URL = trimSlash((import.meta.env.VITE_API_BASE_URL as string | undefined) || 'http://localhost:5000');

/** The lab (EKO) API. Only the support chat still talks to it. */
export const EKO_API_BASE_URL = trimSlash((import.meta.env.VITE_EKO_API_BASE_URL as string | undefined) || 'https://eko.elhamylabs.com');

export const PORTAL_DEVICE_NUMBER = '1';

export const PORTAL_ROOT_PATH = '/account';

export const DOCTOR_ROOT_PATH = '/doctor';

export const PORTAL_LOGIN_PATH = '/login';

export const PORTAL_SESSION_MAX_AGE_MS = 12 * 60 * 60 * 1000;

export { LAB_WHATSAPP_NUMBER } from '@/data/contact';
